module.exports = __webpack_public_path__ + "df94b3e8923309f5ecf0ffb82aebfdc4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-converse.png
// module id = 2542
// module chunks = 0